import { gql } from '@apollo/client'

export const RoomEvents = gql`
    subscription RoomEvents($id: ID!) {
        roomEvents(id: $id) {
            ... on AdminAdded {
                actor {
                    id
                    username
                    avatar
                }
                admin {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    admins {
                        id
                        username
                        avatar
                    }
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on AdminRemoved {
                actor {
                    id
                    username
                    avatar
                }
                admin {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    admins {
                        id
                        username
                        avatar
                    }
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on ChatAdded {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                text
                updated
            }
            ... on ChatRemoved {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on ChatUpdated {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                text
                updated
            }
            ... on ChatReaction {
                actor {
                    id
                    username
                    avatar
                }
                chatId
                emoji
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on ChatReactionRemoved {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on MemberAdded {
                actor {
                    id
                    username
                    avatar
                }
                id
                member {
                    id
                    username
                    avatar
                }
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on MemberRemoved {
                actor {
                    id
                    username
                    avatar
                }
                id
                member {
                    id
                    username
                    avatar
                }
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on MemberUpdated {
                id
                member {
                    id
                    username
                    avatar
                }
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on MusicReaction {
                actor {
                    id
                    username
                    avatar
                }
                id
                reaction
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                track {
                    id
                    album
                    artist
                    bitRate
                    codec
                    composer
                    contributors {
                        id
                        username
                    }
                    coverArt {
                        full
                        thumb250
                        thumb500
                        thumb1200
                    }
                    created
                    date
                    duration
                    files {
                        bitRate
                        duration
                        key
                        size
                    }
                    genre
                    roomId
                    size
                    tags
                    title
                    track
                    updated
                    youtubeId
                }
                updated
            }
            ... on RequestAdded {
                actor {
                    id
                    username
                    avatar
                }
                id
                request {
                    id
                    playTime
                    track {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    user {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                    queue {
                        id
                        playTime
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            id
                            username
                            avatar
                        }
                    }
                }
                updated
            }
            ... on RequestRemoved {
                actor {
                    id
                    username
                    avatar
                }
                id
                request {
                    id
                    playTime
                    track {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    user {
                        id
                        username
                        avatar
                    }
                }
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                    queue {
                        id
                        playTime
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            id
                            username
                            avatar
                        }
                    }
                }
                updated
            }
            ... on RequestSkipped {
                actor {
                    id
                    username
                    avatar
                }
                id
                request {
                    id
                    playTime
                    track {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    user {
                        id
                        username
                        avatar
                    }
                }
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                    queue {
                        id
                        playTime
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            id
                            username
                            avatar
                        }
                    }
                }
                updated
            }
            ... on RequestStarted {
                actor {
                    id
                    username
                    avatar
                }
                id
                request {
                    id
                    playTime
                    track {
                        id
                        album
                        artist
                        bitRate
                        codec
                        composer
                        contributors {
                            id
                            username
                        }
                        coverArt {
                            full
                            thumb250
                            thumb500
                            thumb1200
                        }
                        created
                        date
                        duration
                        files {
                            bitRate
                            duration
                            key
                            size
                        }
                        genre
                        roomId
                        size
                        tags
                        title
                        track
                        updated
                        youtubeId
                    }
                    user {
                        id
                        username
                        avatar
                    }
                }
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                    queue {
                        id
                        playTime
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            id
                            username
                            avatar
                        }
                    }
                }
                updated
            }
            ... on RoomUpdated {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    admins {
                        id
                        username
                        avatar
                    }
                    created
                    id
                    invites {
                        email
                        id
                        issuer {
                            id
                            username
                            avatar
                        }
                        user {
                            id
                            username
                            avatar
                        }
                    }
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                    queue {
                        id
                        playTime
                        track {
                            id
                            album
                            artist
                            bitRate
                            codec
                            composer
                            contributors {
                                id
                                username
                            }
                            coverArt {
                                full
                                thumb250
                                thumb500
                                thumb1200
                            }
                            created
                            date
                            duration
                            files {
                                bitRate
                                duration
                                key
                                size
                            }
                            genre
                            roomId
                            size
                            tags
                            title
                            track
                            updated
                            youtubeId
                        }
                        user {
                            avatar
                            id
                            lastActivity
                            username
                        }
                    }
                    name
                    owner {
                        id
                        username
                        avatar
                    }
                    spinning
                    topic
                    updated
                }
                updated
                updates {
                    name
                    spinning
                    topic
                    invite
                }
            }
            ... on TracksAdded {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                tracks {
                    id
                    album
                    artist
                    bitRate
                    codec
                    composer
                    contributors {
                        id
                        username
                    }
                    coverArt {
                        full
                        thumb250
                        thumb500
                        thumb1200
                    }
                    created
                    date
                    duration
                    files {
                        bitRate
                        duration
                        key
                        size
                    }
                    genre
                    roomId
                    size
                    tags
                    title
                    track
                    updated
                    youtubeId
                }
                updated
            }
            ... on Subscribed {
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                updated
            }
            ... on TracksRemoved {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                tracks {
                    id
                    album
                    artist
                    bitRate
                    codec
                    composer
                    contributors {
                        id
                        username
                    }
                    coverArt {
                        full
                        thumb250
                        thumb500
                        thumb1200
                    }
                    created
                    date
                    duration
                    files {
                        bitRate
                        duration
                        key
                        size
                    }
                    genre
                    roomId
                    size
                    tags
                    title
                    track
                    updated
                    youtubeId
                }
                updated
            }
            ... on TrackUpdated {
                actor {
                    id
                    username
                    avatar
                }
                id
                room {
                    id
                    members {
                        id
                        lastActivity
                        username
                        avatar
                    }
                }
                track {
                    id
                    album
                    artist
                    bitRate
                    codec
                    composer
                    contributors {
                        id
                        username
                    }
                    coverArt {
                        full
                        thumb250
                        thumb500
                        thumb1200
                    }
                    created
                    date
                    duration
                    files {
                        bitRate
                        duration
                        key
                        size
                    }
                    genre
                    roomId
                    size
                    tags
                    title
                    track
                    updated
                    youtubeId
                }
                updated
                updates {
                    tagsAdded
                    tagsRemoved
                }
            }
        }
    }`

export default RoomEvents
